export const preloadImages = (images: string[]): Promise<void> => {
    return new Promise<void>((resolve) => {
        const list: HTMLImageElement[] = [];
        images.forEach((url) => {
            const img = new Image();
            img.onload = () => {
                const index = list.indexOf(img);
                if(index !== -1) {
                    list.splice(index, 1);
                }
                if(list.length === 0) {
                    resolve();
                }
            };
            list.push(img);
            img.src = url;
        });
    });
};
